<template>
  <div class="container">
    <Loading v-if="!requested" />
    <TopNavbar style="text-transform:capitalize;" :title="title" :bgColor="'bg-main'" />
    <div v-if="requested" class="main" ref="main">
      <div class="company-info">{{title}}</div>
      <p v-html="content"></p>
    </div>
  </div>
</template>

<script>
import TopNavbar from "../../components/common/TopNavbar.vue";
import Loading from "../../components/common/Loading.vue";
import { indexPage, updateDishnumOfCategory } from "@/api/api";
import { cartMixin } from "@/mixins/cartMixin";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "index",
  components: {
    TopNavbar,
    Loading,
  },
  data() {
    return {
      requested: true,
      is_weixin: false,
      title: '',
      attr_name: '',
      content: '',
      storeInfo: {},
      mode:1,
      storeid:0
    };
  },
  mixins: [cartMixin],
  mounted() {
  },
  created() {
    const queryParams = this.getUrlParams();
    this.mode = queryParams.mode || 1
    this.storeid = queryParams.storeid || 0
    this.title = queryParams.name == 'tc' ? "Terms & Conditions" : 'Refund Policy'
    this.attr_name = queryParams.name
    this.get_data();
    this.is_weixin = this.isOnWeixin();
  },
  computed: {
  },
  methods: {
    get_data() {
      const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: this.mode, do: "get_storeinfo", storeid: this.storeid });
      console.log('...................', queryParams);
      indexPage("/app/index.php", queryParams)
        .then(res => {
          const indexpage = res.data;
          this.storeInfo = indexpage.store
          switch (this.attr_name) {
            case 'tc':
              this.content = this.storeInfo.shoptc
              break
            case 'policy':
              this.content = this.storeInfo.shoprefundpolicy
              break
          }
          this.requested = true
        })
        .catch(error => {
          this.requested = true
          this.$toast("network timeout");
        })
    }
  }
};
</script>
<style lang="less">
@import url('../../assets/css/common.less');

.container {
  .top-wapper {
    margin: 36px 0 0 0;
    .slides {
      .slide-list {
        img {
          width: 100%;
          display: block;
        }
      }
    }
    .stores {
      background-color: rgba(0, 0, 0, 0.05);
      .call-waiter {
        background-color: rgba(0, 0, 0, 0.35);
        color: @fff;
        padding: 3px 8px;
        border-radius: 15px;
      }
    }

    .merchant-icon {
      border-radius: 50%;
      color: #fff;
      background-color: rgba(105, 105, 105, 0.5);
      position: absolute;
      top: 90px;
      right: 10px;
      padding: 8px;
    }
  }
  .bgRed {
    background-color: @red !important;
  }
  .main {
    margin-top: 35px;
    padding: 10px;
    text-align: left;
    line-height: 22px;
    .company-name {
      font-size: 25px;
      // font-weight: bold;
      text-align: center;
      margin: 20px 0 10px 0;
    }
    .company-info {
      font-size: 20px;
      text-align: center;
      margin: 0 0 20px 0;
    }
  }

  .popup-loading {
    background-color: rgba(255, 255, 255, 0);
    color: #fff;
  }
}
</style>

